import { defineRecipe, defineSlotRecipe } from '@chakra-ui/react';
import { dimensionSelect, lg, md } from '@theme/variants/buttonBar/sizes';

export const buttonBarRecipe = defineRecipe({
  className: 'button-bar-control',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: 2,
    borderRadius: 0,
    border: '2px solid',
    borderColor: 'neutral.800',
    rounded: 'none',
    backgroundColor: 'neutral.900',
    color: 'neutral.300',
    overflow: 'hidden',
    transition: 'none',
    cursor: 'pointer',
    _focusVisible: {
      boxShadow: 'none',
    },
    _hover: {
      backgroundColor: 'neutral.800',
      borderColor: 'skyBlue',
      color: 'neutral.200',
    },
    //This selector is manually used in buttonBar/Root.tsx
    '&[data-active="true"]': {
      backgroundColor: 'neutral.700',
      borderColor: 'neutral.800',
      color: 'skyBlue',
      _hover: {
        color: 'skyBlue',
        backgroundColor: 'neutral.700',
      },
    },
    '&[data-selected="true"]': {
      color: 'colorPalette',
      backgroundColor: 'colorPalette.800',
      _hover: {
        color: 'colorPalette',
        backgroundColor: 'colorPalette.800',
      },
    },
    _disabled: {
      backgroundColor: 'neutral.900',
      color: 'neutral.600',
      cursor: 'default',
    },
  },
  variants: {
    notchPlacement: {
      'top-left': { '&::after': { top: '0', left: '0' } },
      'top-right': { '&::after': { top: '0', right: '0' } },
      'bottom-left': { '&::after': { bottom: '0', left: '0' } },
      'bottom-right': { '&::after': { bottom: '0', right: '0' } },
    },
  },
  defaultVariants: {
    notchPlacement: 'bottom-right',
    colorPalette: 'neutralBlue',
  },
});

export const buttonBarSlotRecipe = defineSlotRecipe({
  className: 'button-bar',
  slots: ['root', 'control', 'portal'],
  base: {
    root: {
      display: 'flex',
      width: 'full',
      height: 'auto',
      _focusVisible: {
        boxShadow: 'none',
      },
    },
    control: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    portal: {
      position: 'relative !important',
      top: '-8px',
      left: '50%',
      transform: 'translate(-50%, -100%)',
    },
  },
  variants: {
    size: {
      md,
      lg,
      dimensionSelect,
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});
